import moment from 'moment'

import { ChartCard, MiniArea, Trend } from '@/components/Charts'
import TrafficsChart from '@/components/DashboardCharts/TrafficsChart'
import DatePicker from '@/components/DatePicker'
import { RDMapChart } from './components'

let intervalTimer

export default {
  name: 'Dashboard',
  components: { ChartCard, MiniArea, Trend, TrafficsChart, RDMapChart, DatePicker },
  data () {
    return {
      loading: true,

      sysStatistic: {},
      toadyTraffics: 0,
      nearly30DaysTraffics: 0,
      nearly30Days: [],

      trafficsGrading: 'hour',
      trafficsHoursDate: moment(),
      trafficsHours: [], // 时粒度访问量数据
      trafficsDays: [], // 日粒度访问量数据
      trafficsMinutes: [], // 分钟粒度访问量数据
      minutesSpanStr: '',

      RDGrading: 'year', // year\month
      RDSearchDate: moment(),
      RDBarColor: ['name', ['#1890ff', '#D06255']],
      RDloading: true,
      RDDatas: [], // 访问总量地域分布数据
      showRDMap: false // 访问总量地域分布地图
    }
  },
  computed: {},
  created() {
    // this.initCharts()
  },
  activated() {
    // this.refreshTrafficsDatasEveryMinute()
  },
  deactivated() {
    clearInterval(intervalTimer)
    intervalTimer = null
  },
  beforeDestroy() {
    clearInterval(intervalTimer)
    intervalTimer = null
  },
  methods: {

  }
}
